/** Minimum options in a group before mobile vertical layout is considered */
export const MOBILE_VERTICAL_OPTION_COUNT_THRESHOLD = 5;

/** Label length above which an option counts as "wide" for mobile layout */
export const MOBILE_VERTICAL_LABEL_LENGTH_THRESHOLD = 5;

/** Minimum wide labels required (exclusive: more than this many) to force mobile vertical */
export const MOBILE_VERTICAL_WIDE_LABEL_COUNT_THRESHOLD = 3;

type OptionWithLabelText = { text: string | null | undefined };

/** Count options whose display text exceeds the wide-label threshold (after trim). */
export const countOptionsWithWideLabels = (
  options: OptionWithLabelText[],
  labelLengthThreshold: number = MOBILE_VERTICAL_LABEL_LENGTH_THRESHOLD,
): number =>
  options.filter(
    (option) => (option.text?.trim().length ?? 0) > labelLengthThreshold,
  ).length;

/**
 * On mobile, stack tile buttons vertically when there are many options and several
 * have non-trivial label text (avoids vertical layout for compact numeric scales).
 */
export const shouldForceVerticalLayoutOnMobile = (
  options: OptionWithLabelText[],
  isMobile: boolean,
): boolean => {
  if (!isMobile || options.length < MOBILE_VERTICAL_OPTION_COUNT_THRESHOLD) {
    return false;
  }

  return (
    countOptionsWithWideLabels(options) >
    MOBILE_VERTICAL_WIDE_LABEL_COUNT_THRESHOLD
  );
};

const formRadioButtonsHelper = {
  MOBILE_VERTICAL_OPTION_COUNT_THRESHOLD,
  MOBILE_VERTICAL_LABEL_LENGTH_THRESHOLD,
  MOBILE_VERTICAL_WIDE_LABEL_COUNT_THRESHOLD,
  countOptionsWithWideLabels,
  shouldForceVerticalLayoutOnMobile,
};

export default formRadioButtonsHelper;
